import { Directive, HostListener, inject, input } from '@angular/core';

import {
    LDFeatureFlags,
    LaunchDarklyTrackingService,
    MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_COUNT,
    MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_OCCURRENCE,
} from '@frontend/sports/launch-darkly/feature';

@Directive({
    selector: '[msLDTracker]',
})
export class LaunchDarklyTrackerDirective {
    menuItemName = input<string>();

    private readonly launchDarklyTrackingService = inject(LaunchDarklyTrackingService);

    @HostListener('click') onClick() {
        this.trackFavouritesMenuItemClick();
    }

    trackFavouritesMenuItemClick() {
        const FAVOURITES_TRACKING_NAME = 'favourites';

        if (this.menuItemName() === FAVOURITES_TRACKING_NAME) {
            this.launchDarklyTrackingService.trackByContext(
                LDFeatureFlags.FavouritesNavigationMenuPosition,
                MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_COUNT,
            );
            this.launchDarklyTrackingService.trackByContext(
                LDFeatureFlags.FavouritesNavigationMenuPosition,
                MAIN_ITEMS_LAUNCH_DARKLY_TRACKING_EVENT_KEY_OCCURRENCE,
            );
        }
    }
}
